import type { FC, ReactNode } from 'react'
import type { EntryKind } from '@/types'

import { cn } from '@/lib/utils'
import { entryKindMeta } from '@/lib/kinds'

interface KindBadgeProps {
    kind: EntryKind
    size?: 'sm' | 'md'
    className?: string
}

export const KindIcon: FC<{ kind: EntryKind, className?: string }> = ({ kind, className }): ReactNode => {
    const meta = entryKindMeta(kind)
    const Icon = meta.icon

    return (
        <span className={cn('inline-flex size-10 shrink-0 items-center justify-center rounded-lg border-2 border-foreground', meta.tone, className)}>
            <Icon className='size-5' aria-hidden='true' />
        </span>
    )
}

const KindBadge: FC<KindBadgeProps> = ({ kind, size = 'sm', className }): ReactNode => {
    const meta = entryKindMeta(kind)
    const Icon = meta.icon

    return (
        <span
            className={cn(
                'inline-flex items-center gap-1 rounded-md border-2 border-foreground font-mono font-bold uppercase tracking-wide',
                meta.tone,
                size === 'sm' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs',
                className
            )}
        >
            <Icon className={size === 'sm' ? 'size-3' : 'size-4'} aria-hidden='true' />
            {meta.label}
        </span>
    )
}

export default KindBadge
